import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 10px;\n  width: auto;\n  margin-right: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: 14px;\n  line-height: 20px;\n  max-width: 438px;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import LockSVG from '../assets/icons/white-lock.svg';
import styled from '../utils/styling/styled-components';
import { HERO_BODY } from '../utils/testing/TestIDs';
import { FadeIn } from '../FadeIn';
import { HeroCard, HeroFootnote } from '../HeroCard/index';
var Header = styled.div(_templateObject());
var Text = styled.div(_templateObject2());
var Lock = styled.img(_templateObject3());
var FootnoteContainer = styled.div(_templateObject4());

var LeafHero = function LeafHero(_ref) {
  var animate = _ref.animate,
      children = _ref.children,
      className = _ref.className,
      expand = _ref.expand,
      gradient = _ref.gradient,
      header = _ref.header,
      inverted = _ref.inverted,
      height = _ref.height,
      footnote = _ref.footnote,
      footnoteLock = _ref.footnoteLock,
      secondary = _ref.secondary,
      text = _ref.text;
  return /*#__PURE__*/React.createElement(HeroCard, {
    animate: animate,
    className: className,
    expand: expand,
    gradient: gradient,
    height: height,
    inverted: inverted,
    secondary: secondary
  }, header && /*#__PURE__*/React.createElement(FadeIn, null, /*#__PURE__*/React.createElement(Header, {
    className: "leaf-hero-header"
  }, header)), text && /*#__PURE__*/React.createElement(FadeIn, null, /*#__PURE__*/React.createElement(Text, {
    className: "leaf-hero-text",
    "data-testid": HERO_BODY
  }, text)), footnote && /*#__PURE__*/React.createElement(FadeIn, null, /*#__PURE__*/React.createElement(FootnoteContainer, null, footnoteLock && /*#__PURE__*/React.createElement(Lock, {
    alt: "",
    src: LockSVG
  }), /*#__PURE__*/React.createElement(HeroFootnote, {
    className: "leaf-hero-footnote"
  }, footnote))), children);
};

export { LeafHero };